<div class="material-list-component">
    <div *ngIf="isBasketScanningEnabled" class="scanning-disabled-container" (click)="disableBasketScanningClicked()">
        <mat-icon svgIcon="cancel" class="scanning-disabled-icon"></mat-icon>
        <span class="bold t3">Disable basket scanning to scan here</span>
    </div>

    <div class="search-container" *ngIf="!isBasketScanningEnabled"
        [ngClass]="{'search-container-set': !hideHeader, 'scanning-disabled':  isBasketScanningEnabled}">
        <app-search-header *ngIf="!hideSearch" [header]="header" [hideHeader]="hideHeader" showKeyboard="true"
            showRefresh="false" [showSearch]="showSearch" showClear="true" [isReadonly]="true"
            [placeholder]="placeHolderText" [disableKeyPress]="disableKeyPress" [showRefresh]="showRefresh"
            (inputFocused)="onSearchHeaderInputFocused($event)" [setSearchInput]="searchInput">
        </app-search-header>
    </div>
    <div class="materials-services-buttons"
        [ngClass]="{'materials-services-buttons-set': !hideHeader, 'scanning-disabled': isBasketScanningEnabled}"
        *ngIf="showMaterialTypeSelector">
        <mat-button-toggle-group (change)="onFilterChange($event)" [value]="selectedFilter">
            <mat-button-toggle value="Materials">
                MATERIALS
            </mat-button-toggle>
            <mat-button-toggle *ngIf="!hideServices" value="Services">
                SERVICES
            </mat-button-toggle>
            <mat-button-toggle *ngIf="packsEnabled && !hidePacks" value="Packs">
                PACKS
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <div class="material-container-list"
        [ngClass]="{'material-container-list-set': hideHeader, 'scanning-disabled': isBasketScanningEnabled}"
        *ngIf="selectedFilter === 'Materials'">
        <div class="material-container-box">
            <cdk-virtual-scroll-viewport itemSize="10">
                <ng-container *cdkVirtualFor="let stock of filteredStocks">
                    <app-material-card *ngIf="!useTheatreCards" [stock]="stock" (stockClicked)="cardClicked($event)">
                    </app-material-card>
                    <app-theatre-material-card *ngIf="useTheatreCards" [stock]="stock"
                        (stockClicked)="cardClicked($event)">
                    </app-theatre-material-card>
                </ng-container>
            </cdk-virtual-scroll-viewport>
        </div>
    </div>
    <div class="material-container-list"
        [ngClass]="{'material-container-list-set': hideHeader, 'scanning-disabled': isBasketScanningEnabled}"
        *ngIf="selectedFilter === 'Services'">
        <div class="material-container-box">
            <cdk-virtual-scroll-viewport itemSize="10">
                <ng-container *cdkVirtualFor="let service of filteredServices">
                    <app-service-card [service]="service" (serviceClicked)="serviceCardClicked($event)">
                    </app-service-card>
                </ng-container>
            </cdk-virtual-scroll-viewport>
        </div>
    </div>
    <div class="material-container-list"
        [ngClass]="{'material-container-list-set': hideHeader, 'scanning-disabled': isBasketScanningEnabled}"
        *ngIf="selectedFilter === 'Packs'">
        <div class="material-container-box">
            <cdk-virtual-scroll-viewport itemSize="10">
                <ng-container *cdkVirtualFor="let pack of filteredPacks">
                    <app-packs-card [pack]="pack" (packClicked)="packCardClicked($event)">
                    </app-packs-card>
                </ng-container>
            </cdk-virtual-scroll-viewport>
        </div>
    </div>
</div>